import { Card, CardMedia, CardContent, Typography, Box } from "@mui/material";
import dayjs from "dayjs";
import { Link } from "react-router";

const BlogCard = ({ image, title, date, excerpt, id }: any) => {
  return (
    <Link
      to={`/news/${id}`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <Card
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          borderRadius: 2,
          backgroundColor: "rgba(255,255,255,0.8)",
          border: "1px solid #d4c4a8",
          mb: 2,
          overflow: "hidden",
        }}
      >
        <CardMedia
          component="img"
          sx={{
            width: { xs: "100%", sm: 220, md: 260 },
            height: { xs: 180, sm: 180, md: 200 },
            objectFit: image ? "cover" : "contain",
            backgroundColor: "#d4b483",
            flexShrink: 0,
            ...(!image && { padding: "12.5%" }),
          }}
          image={image || "/images/no_photo.png"}
          alt={title}
        />

        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <CardContent sx={{ flex: "1 0 auto", py: 2 }}>
            <Typography
              component="h2"
              variant="h6"
              sx={{
                fontFamily: '"Cinzel", serif',
                color: "#4a3728",
                fontSize: "1rem",
                mb: 0.5,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#8a7a68",
                display: "block",
                mb: 1.5,
                fontFamily: '"EB Garamond", serif',
                fontSize: "0.85rem",
              }}
            >
              {dayjs(date).format("MMMM D, YYYY")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#6b5b4a",
                lineHeight: 1.7,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
              dangerouslySetInnerHTML={{
                __html: excerpt?.substring(0, 350) + "...",
              }}
            />
          </CardContent>
        </Box>
      </Card>
    </Link>
  );
};

export default BlogCard;
